
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spa/classes",
      function () {
        return require("private-next-pages/spa/classes/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spa/classes"])
      });
    }
  